import React from "react";
import UpdatesBanner from "../UpdatesBanner/UpdatesBanner";
import SolutionEcosystem from "../WebSite/SolutionEcosystem/SolutionEcosystem";
import AgribusinessService from "./AgribusinessService";
import AgribusinessType from "./AgribusinessType";
import "./Agribusiness.css";
// Main component for Agribusiness
const Agribusiness = () => {
  // List of iDTN (Digital Transformation Network) types
  const types = [
    "CBN/LTN/ARN",
    "DSN",
    "AAMC/AGN",
    "SN",
    "ACN/TN",
    "PPN",
    "BPN",
    "FPN",
  ];

  return (
    <>
      {/* Header section with banner */}
      <UpdatesBanner
        bannerTitle="Micro-ABN"
        bannerbodycopy="Monetize | Improve Yield | Improve Efficiency | Adopt Sustainability | Enable Digital Transformation"
        className="abnbg"
      />

      {/* Overview of Edge AI Network */}
      <SolutionEcosystem title="Overview" type="IDTN" />

      {/* Displaying different types of Edge AI Networks */}
      <AgribusinessType
        md={3}
        types={types}
        title="Micro-ABN Types"
        description="Micro-ABN Network, also called Digital Transformation Network (DTN), can be configured for the following types:"
      />

      {/* Services related to agribusiness */}
      <AgribusinessService />
    </>
  );
};

export default Agribusiness;
